"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("../components/Button"));
var _Avatar = _interopRequireDefault(require("@mui/material/Avatar"));
var _ListItem = _interopRequireDefault(require("@mui/material/ListItem"));
var _ListItemAvatar = _interopRequireDefault(require("@mui/material/ListItemAvatar"));
var _ListItemText = _interopRequireDefault(require("@mui/material/ListItemText"));
var _Book = _interopRequireDefault(require("@mui/icons-material/Book"));
var _theme = require("../theme");
var _i18n = _interopRequireDefault(require("../localization/i18n"));
var _tokens = _interopRequireDefault(require("../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable require-jsdoc */
/**
 * Download the employee booklet
 * @param employee
 * @private
 */
var _downloadManualBooklet = function _downloadManualBooklet(employee) {
  var url = "https://d6hvupc5g7lnm.cloudfront.net/member-booklets/".concat(employee.meta.accountID, "/").concat(employee.meta.classID, ".pdf");
  var link = document.createElement('a');
  var companyName = employee.meta.company.split(' ').join('_');
  link.href = url;
  link.setAttribute('download', "".concat(companyName, "_").concat(employee.meta.cert, ".pdf"));
  link.setAttribute('target', "_blank");
  document.body.appendChild(link);
  link.click();
};
var BookletDownload = function BookletDownload(_ref) {
  var employee = _ref.employee,
    _ref$isListItem = _ref.isListItem,
    isListItem = _ref$isListItem === void 0 ? false : _ref$isListItem,
    whitelabel = _ref.whitelabel,
    getAdminPdf = _ref.getAdminPdf,
    loading = _ref.loading,
    _ref$customStyle = _ref.customStyle,
    customStyle = _ref$customStyle === void 0 ? {} : _ref$customStyle;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    bookletGenerated = _useState2[0],
    setBookletGenerated = _useState2[1];
  var downloadAutoBooklet = function downloadAutoBooklet() {
    getAdminPdf("MemberBooklet", "Booklet.pdf", {
      userID: employee.meta.userID
    }, true);
  };

  // if the member has no manual booklet and is not set to use the auto booklets then return nothing
  if (!employee.meta.hasBooklet && !employee.meta.useAutoBooklet) {
    return null;
  }

  // if the member is set to the use the auto booklets then we need to provide a way to generate them
  if (employee.meta.useAutoBooklet) {
    if (!bookletGenerated) {
      if (isListItem) {
        return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
          button: true,
          onClick: function onClick() {
            setBookletGenerated(true);
            downloadAutoBooklet();
          },
          style: {
            padding: "15px 25px"
          }
        }, /*#__PURE__*/_react["default"].createElement(_ListItemAvatar["default"], null, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
          style: {
            backgroundColor: whitelabel.lightColor || _theme.colors.lightBlue,
            color: whitelabel.primaryColor || _theme.colors.skyBlue
          }
        }, /*#__PURE__*/_react["default"].createElement(_Book["default"], null))), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
          primary: _i18n["default"].t(_tokens["default"].buttons.generateEmployeeBooklet)
        }));
      }
      return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        color: "primary",
        customStyle: {
          height: 50,
          width: 260,
          textTransform: "capitalize",
          fontSize: 16,
          alignSelf: 'flex-end',
          marginBottom: "20px"
        },
        onClick: function onClick() {
          return setBookletGenerated(true);
        }
      }, _i18n["default"].t(_tokens["default"].buttons.generateEmployeeBooklet));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        textDecoration: 'none'
      }
    }, loading ? isListItem ? /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
      style: {
        padding: "15px 25px"
      }
    }, /*#__PURE__*/_react["default"].createElement(_ListItemAvatar["default"], null, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
      style: {
        backgroundColor: whitelabel.lightColor || _theme.colors.lightBlue,
        color: whitelabel.primaryColor || _theme.colors.skyBlue
      }
    }, /*#__PURE__*/_react["default"].createElement(_Book["default"], null))), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
      primary: _i18n["default"].t(_tokens["default"].buttons.generating)
    })) : /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      disabled: true,
      color: "primary",
      customStyle: _objectSpread({
        height: 50,
        width: 180,
        textTransform: "capitalize",
        fontSize: 16,
        alignSelf: 'flex-end'
      }, customStyle)
    }, _i18n["default"].t(_tokens["default"].buttons.generating)) : isListItem ? /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
      button: true,
      style: {
        padding: "15px 25px"
      },
      onClick: function onClick() {
        setBookletGenerated(true);
        downloadAutoBooklet();
      }
    }, /*#__PURE__*/_react["default"].createElement(_ListItemAvatar["default"], null, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
      style: {
        backgroundColor: whitelabel.lightColor || _theme.colors.lightBlue,
        color: whitelabel.primaryColor || _theme.colors.skyBlue
      }
    }, /*#__PURE__*/_react["default"].createElement(_Book["default"], null))), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
      primary: _i18n["default"].t(_tokens["default"].buttons.downloadEmployeeBooklet)
    })) : /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      color: "primary",
      customStyle: _objectSpread({
        height: 50,
        width: 260,
        textTransform: "capitalize",
        fontSize: 16,
        alignSelf: 'flex-end'
      }, customStyle)
    }, _i18n["default"].t(_tokens["default"].buttons.downloadEmployeeBooklet)));
  }
  if (isListItem) {
    return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
      button: true,
      onClick: function onClick() {
        return _downloadManualBooklet(employee);
      },
      style: {
        padding: "15px 25px"
      }
    }, /*#__PURE__*/_react["default"].createElement(_ListItemAvatar["default"], null, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
      style: {
        backgroundColor: whitelabel.lightColor || _theme.colors.lightBlue,
        color: whitelabel.primaryColor || _theme.colors.skyBlue
      }
    }, /*#__PURE__*/_react["default"].createElement(_Book["default"], null))), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
      primary: _i18n["default"].t(_tokens["default"].buttons.downloadEmployeeBooklet)
    }));
  }

  // member has booklet but not auto so load the manual booklet
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    type: "primary",
    customStyle: {
      height: 50,
      width: 260,
      textTransform: "capitalize",
      fontSize: 16,
      alignSelf: 'flex-end',
      marginBottom: "20px"
    },
    onClick: function onClick() {
      return _downloadManualBooklet(employee);
    }
  }, _i18n["default"].t(_tokens["default"].buttons.downloadEmployeeBooklet));
};
var _default = exports["default"] = BookletDownload;